import React from 'react'
import ReportComponents from './ReportComponents'

function CountryReport() {
  return (
    <div className='Appp CountryReport'>
      <ReportComponents />
    </div>
  )
}

export default CountryReport
